import { getLang } from "helpers/themeHelpers";


export const linkToOpenShop = () => {
  const locale = getLang();
  return `${process.env.NEXT_PUBLIC_MYOPENSOOQ_BASE_DOMAIN}?action=upgradeMembership`;
};
